import { em } from 'polished'
import styled from 'styled-components'

export const ImageWrapper = styled.div`
  width: ${em(90)};
  margin-left: -${em(10)};

  ${p => p.theme.mq.upMd} {
    width: ${em(155)};
    margin-left: 0;
    margin-right: ${em(30)};
  }
`

export const WgsIndicators = styled.div`
  grid-area: wgs;
  margin-bottom: ${em(40)};

  ${ImageWrapper} {
    margin-left: -${em(4)};

    ${p => p.theme.mq.upMd} {
      width: ${em(150)};
      margin-right: ${em(24)};
      padding-left: ${em(7)};
    }
  }
`

export const BarWrapper = styled.div`
  padding-top: ${em(14)};
  width: 100%;
`

export const DnaIndicators = styled.div`
  grid-area: dna;

  ${ImageWrapper} {
    width: ${em(88)};
    margin-left: -${em(3)};

    ${p => p.theme.mq.upMd} {
      width: ${em(142)};
      padding-left: ${em(8)};
    }
  }

  ${BarWrapper} {
    ${p => p.theme.mq.upMd} {
      padding-top: ${em(5)};
    }
  }
`

export const ChartWrapper = styled.div`
  padding-top: ${em(14)};

  ${p => p.theme.mq.upMd} {
    display: flex;
    transform: translateX(${em(-13)});
  }

  ${p => p.theme.mq.upLg} {
    transform: none;
  }
`

export const Bar = styled.div`
  margin-bottom: ${em(12)};
  background: ${p =>
    p.isGray
      ? p.theme.colors.whiteOp2
      : 'linear-gradient(90deg, #4C32A0 0%, #7349FF 99.09%)'};
  min-width: ${em(7)};
  height: ${em(15)};
  border-top-right-radius: ${p => p.theme.blocks.blockBorderRadiusLarge};
  border-bottom-right-radius: ${p => p.theme.blocks.blockBorderRadiusLarge};
`
